import { DialogRef } from '@angular/cdk/dialog';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { Injectable, NgZone } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})

export class PopupService {

  constructor(private matDialog: MatDialog, private ngZone: NgZone) { }

  openDialog(component: any, config?: object): MatDialogRef<any> {
    const activeElement = document.activeElement as HTMLElement;
    if(activeElement) {
      activeElement.blur();
    }
    this.matDialog.closeAll();
    config = {
      scrollStrategy: new NoopScrollStrategy(),
      maxWidth: '100vw',
      ...config
    }
    const dialogRef = this.ngZone.run(() => this.matDialog.open(component, config));

    // Close the dialog when a click occurs outside all dialog containers
    const onDocClick = (event: MouseEvent) => {
      const target = event.target as Node;
      const containers = Array.from(document.getElementsByTagName('mat-dialog-container')) as HTMLElement[];
      const clickedInside = containers.some(c => c.contains(target));
      // Ignore clicks inside CDK overlays (e.g. mat-select dropdown panels)
      const overlayContainer = document.querySelector('.cdk-overlay-container');
      const clickedInOverlay = overlayContainer ? overlayContainer.contains(target) : false;
      // Ignore clicks on the OneTrust cookie consent banner, which is rendered outside the CDK overlay container
      const clickedInCookieBanner = (target instanceof Element)
        ? !!target.closest('#onetrust-consent-sdk, #onetrust-banner-sdk, #onetrust-pc-sdk, .onetrust-pc-dark-filter, [id^="onetrust"], [class^="ot-"], [class*=" ot-"]')
        : false;
      if(!clickedInside && !clickedInOverlay && !clickedInCookieBanner) {
        dialogRef.close();
      }
    };
    // use capture phase so we receive clicks early
    document.addEventListener('click', onDocClick, true);

    const sub = dialogRef.afterClosed().subscribe(() => {
      document.removeEventListener('click', onDocClick, true);
      sub.unsubscribe();
    });

    return dialogRef;
  }

  closeDialog(ref: MatDialogRef<any>) {
    ref.close();
  }

  closeCurrentDialog() {
    const activeDialog = this.matDialog.openDialogs[0];
    if(activeDialog) {
      activeDialog.close();
    }
  }

  closeDialogWithResult(result: any, ref: MatDialogRef<any>) {
    ref.close(result);
  }

}